import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ChatOption } from 'projects/chat-common/src/lib/models/chat.option';
import { BrowserModule } from "@angular/platform-browser";
import { IvyFaceAnimatedComponent } from '../../ivy-face-animated/ivy-face-animated.component';
import { IvyFaceComponent } from '../../ivy-face/ivy-face.component';

@Component({
  selector: 'app-general-assistant-card',
  standalone: true,
  imports: [
    IvyFaceAnimatedComponent,
    BrowserModule,
    IvyFaceComponent,
],
  templateUrl: './general-assistant-card.component.html',
  styleUrl: './general-assistant-card.component.scss'
})
export class GeneralAssistantCardComponent {
  choices: { option: ChatOption, emoji: string }[] = ChatOption.generalAssistantOptions();

  @Output()
  onSelect: EventEmitter<ChatOption> = new EventEmitter()

  selectedOption: ChatOption | null = null;

  select(option: ChatOption) {
    this.selectedOption = option;
    this.onSelect.emit(option);
  }

  getOptionClass(option: ChatOption): string {
    const count = this.choices.length;
    const isSelected = this.selectedOption === option;

    if (isSelected) {
      return 'bg-[#E3D7FF] border-[#7B4AE2]';
    }

    return count > 2
      ? 'bg-white border-[#DDB9FD]'
      : 'bg-white border-black';
  }

}
